export default __webpack_public_path__ + "static/media/disney.ecb41911.jpg";